<template>
  <div>
    <!-- {{ getArteSelecionada }} -->
    <div class="mt-n2">
      <v-card outlined tile>
        <v-row class="pa-2" no-gutters>
          <v-col>
            <v-form autocomplete="off">
              <v-row no-gutters>
                <v-btn
                  :disabled="!getArteSelecionada || (getArteSelecionada.status_arte !== '0' && getArteSelecionada.status_arte !== '3')"
                  @click="abrirDialogUpload()"
                  height="32px"
                  color="green"
                  class="mr-2 fs-btns-top"
                  outlined
                  small
                >
                  <v-icon class="mr-1 ml-n1">mdi-upload</v-icon>
                  Upload de Arte Final
                </v-btn>
                <v-btn
                  :disabled="!envioSelecionado || envioSelecionado.status_arte_envio !== '0' || getArteSelecionada.status_arte === '4' || getArteSelecionada.status_arte === '5'"
                  @click="cancelarArte()"
                  height="32px"
                  color="red"
                  class="fs-btns-top"
                  outlined
                  small
                >
                  <v-icon class="mr-1 ml-n1">mdi-close</v-icon>
                  Cancelar Arte
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-col style="max-width: 237px">
            <v-row style="float: right" no-gutters>
              <v-btn
                :disabled="!envioSelecionado || envioSelecionado.status_arte_envio === '2' || envioSelecionado.status_arte_envio === '3' || envioSelecionado.status_arte_envio === '4' || getArteSelecionada.status_arte === '4' || getArteSelecionada.status_arte === '5'"
                height="32px"
                @click="mostrarDialogEmail()"
                color="primary"
                class="fs-btns-top"
                outlined
                small
              >
                <v-icon class="mr-2 ml-n1">mdi-email</v-icon>
                Enviar Email P/ Aprovação
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-dialog width="600px" v-model="dialogUpload">
          <v-card v-if="getArteSelecionada">
            <v-card-title>
              Carregar Nova Arte
              <v-spacer></v-spacer>
              <span style="font-size: 13px">
                  ID: {{ getArteSelecionada.id + ' / PEDIDO: ' + (getArteSelecionada.item && getArteSelecionada.item.ecommerce_carrinho_id !== undefined ? getArteSelecionada.item.ecommerce_carrinho_id : '') }}
              </span>
            </v-card-title>
            <v-divider class="mb-3"/>
            <v-card-text>
              <!-- {{ getArteSelecionada }} -->
              <v-form autocomplete="off">
                <v-text-field
                  label="Nome da Arte *"
                  v-model="novoEnvio.nome_arte"
                  @input="formatUppercase"
                  spellcheck="false"
                  placeholder=" "
                  class="mt-4"
                  hide-details
                  autofocus
                  outlined
                  dense
                />
                <v-row no-gutters>
                  <v-file-input
                    label="Imagem (Upload p/S3 na AWS)"
                    spellcheck="false"
                    id="upload"
                    accept="image/png, image/jpeg, image/bmp"
                    v-model="file"
                    @change="mostrarImagem()"
                    ref="fileInput"
                    class="mt-3"
                    append-outer-icon="mdi-camera"
                    prepend-icon=""
                    placeholder=" "
                    hide-details
                    outlined
                    dense
                  />
                  <v-btn
                    class="ml-3 mt-5 px-1 primary"
                    @click="localizarUltimaArte()"
                    height="20px"
                    hide-details
                    small
                    dense
                  >
                    Localizar Última Arte
                  </v-btn>
                </v-row>
                <img
                  @click="file ? dialogAmpliarArteUpload = true : ''"
                  :src="file ? imagemTmp : require('@/assets/imagem-indisponivel-2.png')"
                  :class="file ? 'fs-img-upload' : 'fs-img-upload-tmp'"
                  alt=""
                >
              </v-form>
            </v-card-text>
            <v-divider class="mt-n2 mb-2"/>
            <v-card-actions class="mx-2 pb-4">
              <v-spacer />
              <v-btn
                :disabled="loading"
                @click="uploadArteFinal()"
                color="primary"
                small
              >
                <v-icon class="mr-1">
                  mdi-upload
                </v-icon>
                Fazer Upload
              </v-btn>
              <v-btn
                :disabled="loading"
                @click="dialogUpload = false"
                color="error"
                small
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-divider />

        <v-row no-gutters>
          <v-col>
            <v-data-table
              height="200px"
              loading-text="Carregando, aguarde..."
              :headers="headers"
              :items="envios.data"
              :items-per-page="9999999"
              hide-default-footer
              hide-action
              item-key="id"
            >
              <template v-slot:body="{ items }">
                <tr
                  v-show="getArteSelecionada"
                  id="fs-row"
                  :class="row === envioSelecionado ? 'fs-row-envioselecionado' : ''"
                  v-for="(row, index) in items"
                  :key="index"
                >
                  <td @click="setRow(row)">{{ row.numero_ultima_arte }}</td>
                  <td @click="setRow(row)">{{ row.nome_arte }}</td>
                  <td @click="setRow(row)">{{ row.created_at | formatarDataHora }}</td>
                  <td @click="setRow(row)">{{ row.updated_at | formatarDataHora }}</td>
                  <td @click="setRow(row)">{{ row.dthr_aprovacao | formatarDataHora }}</td>
                  <td @click="setRow(row)">
                    <v-chip
                      v-if="row.status_arte_envio === '0'"
                      color="white"
                      class="fs-chip"
                      small
                    >
                      Pendente
                    </v-chip>
                    <v-chip
                      v-else-if="row.status_arte_envio === '1'"
                      color="error"
                      class="fs-chip"
                      small
                    >
                      Enviado p/ Aprovação do Cliente
                    </v-chip>
                    <v-chip
                      v-else-if="row.status_arte_envio === '2'"
                      color="primary"
                      class="fs-chip"
                      small
                    >
                      Aprovado Pelo Cliente
                    </v-chip>
                    <v-chip
                      v-else-if="row.status_arte_envio === '3'"
                      color="warning"
                      class="fs-chip"
                      small
                    >
                      Reprovado Pelo Cliente
                    </v-chip>
                    <v-chip
                      v-else-if="row.status_arte_envio === '4'"
                      color="black"
                      dark
                      class="fs-chip"
                      small
                    >
                      Cancelado Pelo Usuário
                    </v-chip>
                  </td>
                  <td @click="setRow(row)">{{ row.comentario_cliente }}</td>
                  <td>
                    <v-menu
                      v-if="getArteSelecionada.status_arte !== '4' && getArteSelecionada.status_arte !== '5'"
                      ref="menuOpcoes"
                      offset-y
                      :nudge-top="68"
                      :nudge-left="40"
                      left
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          @click="setRow(row)"
                          v-on="on"
                          icon
                        >
                          <v-icon>mdi-menu</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="setRow(row); dialogComentario = true">
                          Registrar Comentário
                        </v-list-item>
                        <v-list-item>
                          <v-menu
                            offset-y
                            open-on-hover
                            :nudge-top="60"
                            :nudge-left="79"
                            :close-on-content-click="false"
                            left
                          >
                            <template v-slot:activator="{ on }">
                              <a v-on="on" @click.stop>
                                Alterar Status
                              </a>
                            </template>
                            <v-list>
                              <v-list-item @click="alterarStatus('0', index, row)"><a>Pendente</a></v-list-item>
                              <v-list-item @click="alterarStatus('1', index, row)"><a>Enviado p/ Aprovação</a></v-list-item>
                              <v-list-item @click="alterarStatus('2', index, row)"><a>Aprovado pelo Cliente</a></v-list-item>
                              <v-list-item @click="alterarStatus('3', index, row)"><a>Reprovado pelo Cliente</a></v-list-item>
                            </v-list>
                          </v-menu>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
                <div
                  v-if="(envios.data && !envios.data.length) && !envios.length && getArteSelecionada"
                  class="mt-5"
                  style="text-align: center; position: absolute; width: 100%; color: gray"
                >
                  <v-icon class="mt-n1 mr-1">mdi-alert</v-icon>
                  Não há nenhuma arte/envio associado à esse pedido...
                </div>
                <div
                  v-if="!getArteSelecionada"
                  class="mt-5"
                  style="text-align: center; position: absolute; width: 100%; color: gray"
                >
                  <v-icon class="mt-n1 mr-1">mdi-alert</v-icon>
                  Não há nenhuma arte arte selecionada...
                </div>
              </template>
            </v-data-table>
          </v-col>
          <v-col v-if="envioSelecionado" style="max-width: 220px; border-left: 1px solid rgba(0, 0, 0, 0.1)">
            <div class="pt-1" style="width: 220px; height: 200px; display:table-cell; vertical-align:middle; text-align:center">
              <img
                @click="dialogAmpliarArte = true"
                :src="envioSelecionado.url_arte ? envioSelecionado.url_arte : require('@/assets/imagem-indisponivel-2.png')"
                style="max-width: 190px; border-radius: 4px; cursor: pointer"
              >
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-dialog v-model="dialogEnviarEmail" width="500px">
        <v-card v-if="envioSelecionado">
          <v-card-title>
            Enviar E-mail Para Aprovação
          </v-card-title>
          <v-divider class="mb-3"/>
          <v-card-text>
            <v-form autocomplete="off">
              <v-text-field
                label="E-mails para Envio *"
                v-model="objEnvioEmail.email"
                spellcheck="false"
                placeholder=" "
                class="mt-4"
                hide-details
                autofocus
                outlined
                dense
              />
            </v-form>
          </v-card-text>
          <v-divider class="mt-1 mb-2"/>
          <v-card-actions class="mx-2 pb-4">
            <v-spacer />
            <v-btn
              :disabled="loading"
              @click="enviarEmailParaAprovacao()"
              color="primary"
              small
            >
              <v-icon class="mr-1">
                mdi-upload
              </v-icon>
              Enviar Para Aprovação
            </v-btn>
            <v-btn
              :disabled="loading"
              @click="dialogEnviarEmail = false"
              color="error"
              small
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAmpliarArte" width="700px">
        <v-card v-if="envioSelecionado" class="pl-1 pt-5">
          <v-btn style="position: absolute; right: 0; top: 0" color="error" large icon @click="dialogAmpliarArte = false">
            <v-icon style="font-size: 30px !important">mdi-close-circle</v-icon>
          </v-btn>
          <br>
          <img
            :src="envioSelecionado.url_arte"
            style="width: 690px; max-width: 89vw; border-radius: 5px"
            alt=""
          >
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAmpliarArteUpload" width="700px">
        <v-card class="pl-1 pt-5">
          <v-btn style="position: absolute; right: 0; top: 0" color="error" large icon @click="dialogAmpliarArteUpload = false">
            <v-icon style="font-size: 30px !important">mdi-close-circle</v-icon>
          </v-btn>
          <br>
          <img
            :src="imagemTmp"
            style="width: 690px; max-width: 89vw; border-radius: 5px"
            alt=""
          >
        </v-card>
      </v-dialog>

      <v-dialog v-if="envioSelecionado" v-model="dialogComentario" width="600px">
        <v-card>
          <v-card-title>
            Adicionar Comentário
          </v-card-title>
          <v-divider class="mb-5"/>
          <v-card-text>
            <v-textarea
              autofocus
              outlined
              label="Comentário"
              spellcheck="false"
              v-model="envioSelecionado.comentario_cliente"
              placeholder="Digite um comentário."
            ></v-textarea>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              class="success"
              @click="registrarComentario()"
            >
              <v-icon class="ml-n1 mr-1">mdi-check-circle</v-icon>
              Registrar Comentário
            </v-btn>
            <v-btn
              dark
              color="red"
              @click="dialogComentario = false"
            >
              <v-icon class="ml-n1 mr-1">mdi-cancel</v-icon>
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="loading" z-index="5000">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { list, list2, add, edit, del } from '@/api/crud' // eslint-disable-line
import * as api from '@/api/controledeartes' // eslint-disable-line
import http from '@/services/http'

import moment from 'moment'

export default {
  data () {
    return {
      headers: [
        { text: 'NUMERO', value: 'numero_ultima_arte' },
        { text: 'NOME ARTE', value: 'nome_arte' },
        { text: 'DT/HR CRIAÇÃO', value: 'created_at' },
        { text: 'ULT. INTERAÇÃO', value: 'updated_at' },
        { text: 'DT/HR APROVAÇÃO', value: 'dthr_aprovacao' },
        { text: 'STATUS', value: 'status_arte_envio' },
        { text: 'COMENTÁRIO', value: 'comentario_cliente' },
        { text: '' }
      ],
      dialogComentario: false,
      objEnvioEmail: {},
      dialogAmpliarArte: false,
      dialogAmpliarArteUpload: false,
      dialogEnviarEmail: false,
      envioSelecionado: null,
      imagemTmp: require('@/assets/imagem-indisponivel-2.png'),
      filtros: {},
      filtroComposto: [],
      novoEnvio: {},
      envios: [],
      loading: false,
      dialogUpload: false,
      file: null,
      limit: 5,
      page: 1
    }
  },
  filters: {
    formatarCNPJ (cnpj) {
      if (cnpj === null) {
        return ''
      }
      let mascara = cnpj.replace(/\D/g, '')
      if (mascara.length <= 14) {
        mascara = mascara.replace(/^(\d{2})(\d)/, '$1.$2')
        mascara = mascara.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        mascara = mascara.replace(/\.(\d{3})(\d)/, '.$1/$2')
        mascara = mascara.replace(/(\d{4})(\d)/, '$1-$2')
      }
      return mascara
    },
    formatarData (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    formatarDataHora (value) {
      if (value) return moment(value).format('DD/MM/YYYY HH:mm')
    }
  },
  watch: {
    getArteSelecionada: {
      handler: async function (item) {
        if (!item) {
          this.envioSelecionado = null
          this.filtros = {}
          this.envios = []
          this.novoEnvio = {}
          this.imagemTmp = require('@/assets/imagem-indisponivel-2.png')
          this.file = null
        } else if (this.filtros.arte_personalizada_id !== item.id) {
          this.envioSelecionado = null
          this.filtros = { arte_personalizada_id: item.id }
          this.novoEnvio = {}
          this.imagemTmp = require('@/assets/imagem-indisponivel-2.png')
          this.file = null
          this.filtrar()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('controledeartes', ['getArteSelecionada']),
    ...mapState({
      confirm: state => state.global.confirm
    })
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar',
      SETARTESELECIONADA: 'controledeartes/SETARTESELECIONADA'
    }),
    async localizarUltimaArte () {
      this.loading = true
      try {
        const url = await http.get(`/crm/geturlartefinal/${this.getArteSelecionada.cliente_id}/${this.getArteSelecionada.ecommerce_carrinho_item_id}`)
        if (url.length) {
          this.imagemTmp = process.env.VUE_APP_BASE_URL + '/crm/getartefinal/' + url
          const aux = await fetch(this.imagemTmp).then(r => r.blob())
          this.file = aux
        } else {
          this.setSnackbar({ msg: 'Não foi encontrada nenhuma arte desse cliente.', color: 'red', timeout: 7000 })
        }
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
      }
      this.loading = false
    },
    abrirDialogUpload () {
      const pendentes = this.envios.data.filter(x => {
        return x.status_arte_envio === '0'
      })
      if (pendentes.length) {
        this.setSnackbar({ msg: 'O pedido selecionado possui artes pendentes!', color: 'red', timeout: 7000 })
      } else {
        if (this.envios.data.length) {
          this.novoEnvio.nome_arte = this.envios.data[0].nome_arte
        }
        this.dialogUpload = true
      }
    },
    async enviarEmailParaAprovacao () {
      this.loading = true
      if (this.objEnvioEmail.email.length) {
        try {
          this.objEnvioEmail.arte = this.getArteSelecionada
          this.objEnvioEmail.envio = this.envioSelecionado
          const res = await api.enviarEmailAprovacao(this.objEnvioEmail)
          this.getArteSelecionada.status_arte = res.status_arte_envio
          this.envioSelecionado.status_arte_envio = res.status_arte_envio
          this.envioSelecionado.updated_at = res.updated_at
          this.setSnackbar({ msg: 'Email enviado com sucesso!', color: 'success', timeout: 3000 })
          this.dialogEnviarEmail = false
          this.objEnvioEmail = {}
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
        }
      } else {
        this.setSnackbar({ msg: 'Informe o e-mail corretamente!', color: 'red', timeout: 4000 })
      }
      this.loading = false
    },
    async registrarComentario () {
      if (this.getArteSelecionada.status_arte === '4') {
        this.setSnackbar({ msg: 'Esse processo está finalizado, portanto não é possível alterar.', color: 'red' })
      } else {
        const obj = {
          id: this.envioSelecionado.id,
          comentario_cliente: this.envioSelecionado.comentario_cliente
        }
        try {
          await edit('/crm/controleartesenvio', 'edit', obj.id, obj)
          this.dialogComentario = false
          this.setSnackbar({ msg: 'Comentário registrado com sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
      }
    },
    async alterarStatus (status, index, item) {
      this.$refs.menuOpcoes[index].isActive = false
      if (this.getArteSelecionada.status_arte === '4') {
        this.setSnackbar({ msg: 'Esse processo está finalizado, portanto não é possível alterar.', color: 'red' })
      } else {
        const obj = {
          id: item.id,
          status_arte_envio: status
        }
        try {
          if (status === '2') {
            obj.dthr_aprovacao = new Date()
          } else {
            obj.dthr_aprovacao = ''
          }
          await edit('/crm/controleartesenvio', 'edit', obj.id, obj)
          await edit('/crm/controleartes', 'edit', this.getArteSelecionada.id, { status_arte: status })
          this.getArteSelecionada.status_arte = status
          this.envioSelecionado.status_arte_envio = status
          this.envioSelecionado.dthr_aprovacao = obj.dthr_aprovacao
          this.setSnackbar({ msg: 'Status atualizado com sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
      }
    },
    async cancelarArte () {
      if (this.envioSelecionado) {
        if (await this.confirm.open('Cancelar Envio', 'Tem certeza que deseja continuar?', { color: 'red' })) {
          try {
            const obj = {
              id: this.envioSelecionado.id,
              status_arte_envio: '4'
            }
            await edit('/crm/controleartesenvio', 'edit', obj.id, obj)
            this.envioSelecionado.status_arte_envio = '4'
            this.setSnackbar({ msg: 'Envio cancelado!', color: 'success', timeout: 3000 })
          } catch (error) {
            this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
          }
        }
      }
    },
    setRow (row) {
      this.envioSelecionado = row
    },
    formatUppercase () {
      if (this.novoEnvio.nome_arte) {
        this.novoEnvio.nome_arte = this.novoEnvio.nome_arte.toUpperCase()
      }
    },
    mostrarDialogEmail () {
      // console.log(this.getArteSelecionada.item.carrinho.email)
      if ((this.getArteSelecionada.item === null) || (this.getArteSelecionada.item === undefined) || (this.getArteSelecionada.item.carrinho === undefined)) {
        this.setSnackbar({ msg: 'Esta rotina só funciona para Artes da FORTKOL!', color: 'red', timeout: 4000 })
      } else {
        this.objEnvioEmail.email = this.getArteSelecionada.item.carrinho.email
        this.objEnvioEmail.whatsapp = this.getArteSelecionada.item.carrinho.whatsapp
        this.dialogEnviarEmail = true
      }
    },
    async mostrarImagem () {
      if (this.file) this.imagemTmp = URL.createObjectURL(this.file)
    },
    async uploadArteFinal () {
      this.loading = true
      if (this.file && this.novoEnvio.nome_arte) {
        const arteID = this.getArteSelecionada.id
        const formData = new FormData()
        const obj = {
          hello: 'world'
        }
        formData.append('file', this.file, this.novoEnvio.nome_arte)
        formData.append('data', obj)
        try {
          const res = await api.uploadArteFinal(formData, arteID)
          this.getArteSelecionada.status_arte = res.arte.status_arte
          this.getArteSelecionada.nome_arte = res.arte.nome_arte
          this.filtrar()
          this.dialogUpload = false
          this.setSnackbar({ msg: 'Arte carregada com Sucesso!', color: 'success', timeout: 4000 })
          this.file = null
          this.imagemTmp = require('@/assets/imagem-indisponivel-2.png')
          this.novoEnvio = {}
        } catch (e) {
          this.setSnackbar({ msg: 'Ocorreu um erro ao fazer upload!', color: 'red', timeout: 4000 })
        }
      } else {
        this.setSnackbar({ msg: 'Informe o nome da arte e faça o carregamento do arquivo!', color: 'red' })
      }
      this.loading = false
    },
    async filtrar () {
      this.loading = true
      this.montarFiltroComposto()
      const obj = {
        tipo: 'filtro',
        query: this.querySerialize('filtro', this.filtroComposto)
      }
      try {
        this.envios = await list2('/crm/controleartesenviofiltro', obj)
        this.dialogFiltros = false
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
      this.loading = false
    },
    async montarFiltroComposto () {
      this.filtroComposto = []
      const keys = Object.keys(this.filtros)
      for (let i = 0; i < keys.length; i++) {
        if (!this.filtros[keys[i]] || this.filtros[keys[i]] === '') { continue }
        if (typeof this.filtros[keys[i]] === 'object' && !this.filtros[keys[i]].length) { continue }
        if (this.filtros[keys[i]]) {
          const type = this.filtros[keys[i]].length ? typeof this.filtros[keys[i]][0] : typeof this.filtros[keys[i]]
          this.filtroComposto.push({ field: keys[i], value: this.filtros[keys[i]], type })
        }
      }
    },
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    querySerialize (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) query = query + nome
        query = query + encodeURIComponent(`[${i}]`) + '=' + encodeURIComponent(JSON.stringify(filtro[i]))
        if (i < filtro.length - 1) query = query + `&${nome}`
      }
      query = query.replace(/%2C/g, ',')
      return query
    }
  }
}
</script>

<style scoped>
#fs-row {
  border-bottom: 1px solid rgba(0,0,0,.12);
}
#fs-row:hover {
  cursor: pointer;
  background-color: rgba(238, 238, 238, 0.712);
}
.fs-row-envioselecionado {
  background-color: rgba(238, 238, 238, 0.712);
}
.fs-btn-limit {
  font-size: 11px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 9px !important;
  font-size: 12px !important;
}
.fs-btns-top:active, .fs-btns-top:focus {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-img-upload {
  margin-top: 12px;
  width: 553px;
  max-width: 553px;
  border: 1px solid rgb(185, 185, 185);
  border-radius: 4px;
}
.fs-img-upload-tmp {
  margin-top: 12px;
  width: 200px;
  max-width: 200px;
  height: 190px;
  max-height: 190px;
  border: 1px solid rgb(185, 185, 185);
  border-radius: 4px;
}
</style>
